import { Col, Container, Form, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import i1 from "../../../../Assets/images/authBg.png";
import React, { useEffect, useState } from "react";
import {
  DELETE_JOB_POST,
  EVENT_LIST,
  GET_USER_BY_ID,
  USER_STATUS_CHANGE,
} from "../../../../services/ApiCalls";
import {
  catchAsync,
  checkResponse,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../utilities/utilities";
import moment from "moment";
import Loader from "../../../../components/Common/Loader";
import TableLayout from "../../../../components/TableLayout";
import TableActions from "../../../../components/Common/TableActions";
import dataHandler from "../../../../hooks/dataHandler";
import { defaultDeleteModelState } from "../../../../utilities/const";
import ConfirmationPop from "../../../../components/Modals/ConfirmationPop";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const dataDummy = [
  {
    _id: "1",
    bookingId: "BK-2025-001",
    description: "Corporate event booking for product launch",
    location: {
      address: "123 Business Street, New Delhi, India",
    },
    totalPrice: 25000,
    bookingDate: "2025-09-01T14:30:00Z",
  },
  {
    _id: "2",
    bookingId: "BK-2025-002",
    description: "Wedding reception hall booking",
    location: {
      address: "456 Celebration Avenue, Mumbai, India",
    },
    totalPrice: 50000,
    bookingDate: "2025-09-02T18:00:00Z",
  },
];

const UserDetail = () => {
  const [loader, setLoader] = useState(false);
  const [userDetails, setUserUserDetails] = useState();
  const [profileImage, setProfileImage] = useState();
  const { id } = useParams();
  const { t } = useTranslation();

  const [status, setStatus] = useState();

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_USER_BY_ID(id);
    console.log(res, "user details api=======<>");
    const success = checkResponse({
      res,
      setData: setUserUserDetails,
      setLoader,
    });
    if (success) {
      setStatus(res?.data?.data?.status);
      setProfileImage(res?.data?.data?.profileImage);
    }
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const {
    setBody,
    statusChangeHandler,
    body,
    data,
    loader2,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    refetch,
    deleteHandler,
  } = dataHandler({
    api: EVENT_LIST,
    extraBody: { orgniser: id },
  });

  const handleStatusChange = async (e) => {
    const newStatus = e.target.checked ? "active" : "inactive";

    if (!id) return;
    let res = await USER_STATUS_CHANGE({
      _id: id,
      status: newStatus,
    });

    if (res?.data?.status === "success") {
      toast.success(`User status changed to ${newStatus}`);
      setStatus(newStatus);
    } else {
      toast.error(res?.data?.message || "Failed to change user status");
    }
  };

  const column = [
    {
      head: "Sr. No.",
      accessor: "#",
      component: (item, key) => key + 1,
    },

    { head: "BookingId", accessor: "bookingId" },
    { head: "Description", accessor: "description" },

    {
      head: "Location",
      accessor: "location",
      component: (item) => <>{item?.location?.address}</>,
    },

    {
      head: "Total Price",
      accessor: "totalPrice",
      component: (item) => <>{item?.totalPrice}</>,
    },

    {
      head: "Booking Date",
      accessor: "bookingDate",
      component: (item) => (
        <>{moment(item?.bookingDate).format("MM-DD-YYYY , HH:mm")}</>
      ),
    },
  ];

  console.log(data, "data==55555==<>");
  console.log(status, "status========<>");
  return (
    <>
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel((p) => defaultDeleteModelState)}
        confirmHandler={() =>
          deleteHandler(() => DELETE_JOB_POST({ _id: deleteModel.dumpId }))
        }
        type={"delete"}
      />
      {loader && <Loader />}
      <section className="userDetail py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/manage-user"
                  className="border d-flex align-items-center text-white p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("manageUser.userDetail")}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Row className="justify-content-between">
                  <Col lg="12" className="my-2">
                    <div className="text-end">
                      <div className="d-inline-flex align-items-center gap-10">
                        <label
                          htmlFor="custom-switch"
                          className="form-label m-0 text-muted fw-sbold"
                        >
                          {t("manageUser.status")}
                        </label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          checked={status === "active"}
                          onChange={handleStatusChange}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg="12" className="my-2">
                    <div
                      className="imgWrp text-center mx-auto"
                      style={{ maxWidth: "max-content" }}
                    >
                      <img
                        src={profileImage || i1}
                        style={{ height: 140, width: 140 }}
                        alt=""
                        className="img-fluid rounded-circle object-fit-cover"
                      />
                    </div>
                  </Col>
                  <Col md={6} className="my-2">
                    <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {t("manageUser.fullName")}:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.name
                            ? userDetails?.name
                            : userDetails?.first_name +
                              " " +
                              userDetails?.last_name}
                        </h6>
                      </li>

                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {" "}
                          {t("manageUser.email")}:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {userDetails?.email}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {t("manageUser.columns.status")}:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {removeUnderScoreAndCapitalizeFirstLetter(
                            userDetails?.status
                          )}
                        </h6>
                      </li>
                    </ul>
                  </Col>

                  <Col md={6} className="my-2">
                    <ul className="list-unstyled mb-0 notLastBorder ps-lg-3">
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {t("manageUser.phoneNumber")}:
                        </p>
                        <p className="m-0 text-muted fw-bold w-50">
                          {userDetails?.mobileNumber}
                        </p>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {t("manageUser.createdAt")}:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {moment(userDetails?.date_created_utc).format(
                            "MM-DD-YYYY, HH:MM"
                          )}
                        </h6>
                      </li>
                      <li className="py-3 d-flex align-items-center gap-10">
                        <p className="m-0 themeBlue fw-sbold w-25">
                          {t("manageUser.updatedAt")}:
                        </p>
                        <h6 className="m-0 text-muted fw-bold w-50">
                          {moment(userDetails?.data_profile_update_utc).format(
                            "MM-DD-YYYY , HH:MM"
                          )}
                        </h6>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <h5 className="mb-3 fw-bold ">User Booking Details</h5>
              <TableLayout column={column} data={dataDummy} loader={false} />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default UserDetail;
